import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import './EditLoan.scss';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import Sidebar from '../../sidebar/sidebar';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'date-fns';
import {BaseUrl} from "../../../Environment";
import { withNamespaces } from 'react-i18next';
import { getSecureItem } from '../../../utilsFunctions';
import Select from "react-select";
import { Grid, Typography } from '@mui/material';

const axios = require('axios')
const tenureOptions = [
    { value: "Daily", label: "Daily" },
    { value: "Weekly", label: "Weekly" },
    { value: "Bi-Weekly", label: "Bi-Weekly" },
    { value: "Monthly", label: "Monthly" },
    { value: "Ten_Daily", label: "Ten Days" },
    { value: "One Time", label: "One Time" },
];
class EditLoan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loanTypeBorder:"1px solid #D4D4D5",
            loanAmuontRangeBorder1:"1px solid #D4D4D5",
            loanAmuontRangeBorder2:"1px solid #D4D4D5",
            rateOfRangeInterestBorder1:"1px solid #D4D4D5",
            rateOfRangeInterestBorder2:"1px solid #D4D4D5",
            loanTenureMonthsBorder1:"1px solid #D4D4D5",
            loanTenureMonthsBorder2:"1px solid #D4D4D5",
            loanTenureWeeksBorder1:"1px solid #D4D4D5",
            loanTenureWeeksBorder2:"1px solid #D4D4D5",
            loanTenureDaysBorder1:"1px solid #D4D4D5",
            loanTenureDaysBorder2:"1px solid #D4D4D5",
            loanTenureDays1Border:"1px solid #D4D4D5",
            clicked: false,
            SelectedDate:new Date().toLocaleString(),
            openmodal : false,
            curTime:new Date().toLocaleString(),
            submitted: false,
            loanType:"",
            loanAmuontRangefrom:"",
            loanAmuontRangeto:"",
            fixedRoi: "",
            rateOfRangeInterestfrom:"",
            rateOfRangeInterestto:"",
            loanTenureMonthsfrom:"",
            loanTenureMonthsto:"",
            loanTenureWeeksfrom:"",
            loanTenureWeeksto:"",
            loanTenureDaysfrom:"",
            loanTenureDaysto: "",
            fixedLoanTenureType: "",
            fixedLoanDuration: "",
            fixedLoanAmount: "",
            fixedProcessingFee: "",
            fixedLoanCollectedAmount: "",
        };
       
         
        this.loanType = this.loanType.bind(this)
        this.loanAmuontRange1 = this.loanAmuontRange1.bind(this)
        this.loanTenureDays1 = this.loanTenureDays1.bind(this)



        this.rateOfRangeInterestBox1 = this.rateOfRangeInterestBox1.bind(this)
        this.rateOfRangeInterestBox2 = this.rateOfRangeInterestBox2.bind(this)
         this.loanAmuontRange2 = this.loanAmuontRange2.bind(this)
         this.loanTenureMonthsBox1 = this.loanTenureMonthsBox1.bind(this)
         this.loanTenureMonthsBox2 = this.loanTenureMonthsBox2.bind(this)
         this.loanTenureWeeksBox1 = this.loanTenureWeeksBox1.bind(this)
         this.loanTenureWeeksBox2 = this.loanTenureWeeksBox2.bind(this)


         this.loanTenureDaysBox1 = this.loanTenureDaysBox1.bind(this)
         this.loanTenureDaysBox2 = this.loanTenureDaysBox2.bind(this)
          }
       
        loanType(){
            this.setState({
          
            loanTypeBorder:"1px solid #13c902",
            loanAmuontRangeBorder1:"1px solid #D4D4D5",
            loanAmuontRangeBorder2:"1px solid #D4D4D5",
            rateOfRangeInterestBorder1:"1px solid #D4D4D5",
            rateOfRangeInterestBorder2:"1px solid #D4D4D5",
            loanTenureMonthsBorder1:"1px solid #D4D4D5",
            loanTenureMonthsBorder2:"1px solid #D4D4D5",
            loanTenureWeeksBorder1:"1px solid #D4D4D5",
            loanTenureWeeksBorder2:"1px solid #D4D4D5",
            loanTenureDaysBorder1:"1px solid #D4D4D5",
            loanTenureDaysBorder2:"1px solid #D4D4D5",
            })
            
        } 
        loanAmuontRange1(){
            this.setState({
            
            loanTypeBorder:"1px solid #D4D4D5",
            loanAmuontRangeBorder1:"1px solid #13c902",
            loanAmuontRangeBorder2:"1px solid #D4D4D5",
            rateOfRangeInterestBorder1:"1px solid #D4D4D5",
            rateOfRangeInterestBorder2:"1px solid #D4D4D5",
            loanTenureMonthsBorder1:"1px solid #D4D4D5",
            loanTenureMonthsBorder2:"1px solid #D4D4D5",
            loanTenureWeeksBorder1:"1px solid #D4D4D5",
            loanTenureWeeksBorder2:"1px solid #D4D4D5",
            loanTenureDaysBorder1:"1px solid #D4D4D5",
            loanTenureDaysBorder2:"1px solid #D4D4D5",
          
            })
            
        }
        loanAmuontRange2(){
            this.setState({
            
            loanTypeBorder:"1px solid #D4D4D5",
            loanAmuontRangeBorder1:"1px solid #D4D4D5",
            loanAmuontRangeBorder2:"1px solid #D4D4D5",
            rateOfRangeInterestBorder1:"1px solid #D4D4D5",
            rateOfRangeInterestBorder2:"1px solid #13c902",
            loanTenureMonthsBorder1:"1px solid #D4D4D5",
            loanTenureMonthsBorder2:"1px solid #D4D4D5",
            loanTenureWeeksBorder1:"1px solid #D4D4D5",
            loanTenureWeeksBorder2:"1px solid #D4D4D5",
            loanTenureDaysBorder1:"1px solid #D4D4D5",
            loanTenureDaysBorder2:"1px solid #D4D4D5",
          
            })
            
        }

        rateOfRangeInterestBox1(){
            this.setState({
            
            loanTypeBorder:"1px solid #D4D4D5",
            loanAmuontRangeBorder1:"1px solid #D4D4D5",
            loanAmuontRangeBorder2:"1px solid #D4D4D5",
            rateOfRangeInterestBorder1:"1px solid #13c902",
            rateOfRangeInterestBorder2:"1px solid #D4D4D5",
            loanTenureMonthsBorder1:"1px solid #D4D4D5",
            loanTenureMonthsBorder2:"1px solid #D4D4D5",
            loanTenureWeeksBorder1:"1px solid #D4D4D5",
            loanTenureWeeksBorder2:"1px solid #D4D4D5",
            loanTenureDaysBorder1:"1px solid #D4D4D5",
            loanTenureDaysBorder2:"1px solid #D4D4D5",
          
            })
            
        }
        rateOfRangeInterestBox2(){
            this.setState({
            
            loanTypeBorder:"1px solid #D4D4D5",
            loanAmuontRangeBorder1:"1px solid #D4D4D5",
            loanAmuontRangeBorder2:"1px solid #D4D4D5",
            rateOfRangeInterestBorder1:"1px solid #D4D4D5",
            rateOfRangeInterestBorder2:"1px solid #13c902",
            loanTenureMonthsBorder1:"1px solid #D4D4D5",
            loanTenureMonthsBorder2:"1px solid #D4D4D5",
            loanTenureWeeksBorder1:"1px solid #D4D4D5",
            loanTenureWeeksBorder2:"1px solid #D4D4D5",
            loanTenureDaysBorder1:"1px solid #D4D4D5",
            loanTenureDaysBorder2:"1px solid #D4D4D5",
          
            })
            
        }


        loanTenureMonthsBox1(){
            this.setState({
            
            loanTypeBorder:"1px solid #D4D4D5",
            loanAmuontRangeBorder1:"1px solid #D4D4D5",
            loanAmuontRangeBorder2:"1px solid #D4D4D5",
            rateOfRangeInterestBorder1:"1px solid #D4D4D5",
            rateOfRangeInterestBorder2:"1px solid #D4D4D5",
            loanTenureMonthsBorder1:"1px solid #13c902",
            loanTenureMonthsBorder2:"1px solid #D4D4D5",
            loanTenureWeeksBorder1:"1px solid #D4D4D5",
            loanTenureWeeksBorder2:"1px solid #D4D4D5",
            loanTenureDaysBorder1:"1px solid #D4D4D5",
            loanTenureDaysBorder2:"1px solid #D4D4D5",
          
            })

        }
        loanTenureMonthsBox2(){
            this.setState({
            
            loanTypeBorder:"1px solid #D4D4D5",
            loanAmuontRangeBorder1:"1px solid #D4D4D5",
            loanAmuontRangeBorder2:"1px solid #D4D4D5",
            rateOfRangeInterestBorder1:"1px solid #D4D4D5",
            rateOfRangeInterestBorder2:"1px solid #D4D4D5",
            loanTenureMonthsBorder1:"1px solid #D4D4D5",
            loanTenureMonthsBorder2:"1px solid #13c902",
            loanTenureWeeksBorder1:"1px solid #D4D4D5",
            loanTenureWeeksBorder2:"1px solid #D4D4D5",
            loanTenureDaysBorder1:"1px solid #D4D4D5",
            loanTenureDaysBorder2:"1px solid #D4D4D5",
          
            })

        }
        
        loanTenureWeeksBox1(){
            this.setState({
            
            loanTypeBorder:"1px solid #D4D4D5",
            loanAmuontRangeBorder1:"1px solid #D4D4D5",
            loanAmuontRangeBorder2:"1px solid #D4D4D5",
            rateOfRangeInterestBorder1:"1px solid #D4D4D5",
            rateOfRangeInterestBorder2:"1px solid #D4D4D5",
            loanTenureMonthsBorder1:"1px solid #D4D4D5",
            loanTenureMonthsBorder2:"1px solid #D4D4D5",
            loanTenureWeeksBorder1:"1px solid #13c902",
            loanTenureWeeksBorder2:"1px solid #D4D4D5",
            loanTenureDaysBorder1:"1px solid #D4D4D5",
            loanTenureDaysBorder2:"1px solid #D4D4D5",
          
            })

        }

        loanTenureWeeksBox2(){
            this.setState({
            
            loanTypeBorder:"1px solid #D4D4D5",
            loanAmuontRangeBorder1:"1px solid #D4D4D5",
            loanAmuontRangeBorder2:"1px solid #D4D4D5",
            rateOfRangeInterestBorder1:"1px solid #D4D4D5",
            rateOfRangeInterestBorder2:"1px solid #D4D4D5",
            loanTenureMonthsBorder1:"1px solid #D4D4D5",
            loanTenureMonthsBorder2:"1px solid #D4D4D5",
            loanTenureWeeksBorder1:"1px solid #D4D4D5",
            loanTenureWeeksBorder2:"1px solid #13c902",
            loanTenureDaysBorder1:"1px solid #D4D4D5",
            loanTenureDaysBorder2:"1px solid #D4D4D5",
          
            })

        }

        loanTenureDaysBox1(){
            this.setState({
            
            loanTypeBorder:"1px solid #D4D4D5",
            loanAmuontRangeBorder1:"1px solid #D4D4D5",
            loanAmuontRangeBorder2:"1px solid #D4D4D5",
            rateOfRangeInterestBorder1:"1px solid #D4D4D5",
            rateOfRangeInterestBorder2:"1px solid #D4D4D5",
            loanTenureMonthsBorder1:"1px solid #D4D4D5",
            loanTenureMonthsBorder2:"1px solid #D4D4D5",
            loanTenureWeeksBorder1:"1px solid #D4D4D5",
            loanTenureWeeksBorder2:"1px solid #D4D4D5",
            loanTenureDaysBorder1:"1px solid #13c902",
            loanTenureDaysBorder2:"1px solid #D4D4D5",
          
            })

        }



        loanTenureDaysBox2(){
            this.setState({
            
            loanTypeBorder:"1px solid #D4D4D5",
            loanAmuontRangeBorder1:"1px solid #D4D4D5",
            loanAmuontRangeBorder2:"1px solid #D4D4D5",
            rateOfRangeInterestBorder1:"1px solid #D4D4D5",
            rateOfRangeInterestBorder2:"1px solid #D4D4D5",
            loanTenureMonthsBorder1:"1px solid #D4D4D5",
            loanTenureMonthsBorder2:"1px solid #D4D4D5",
            loanTenureWeeksBorder1:"1px solid #D4D4D5",
            loanTenureWeeksBorder2:"1px solid #D4D4D5",
            loanTenureDaysBorder1:"1px solid #D4D4D5",
            loanTenureDaysBorder2:"1px solid #13c902",
          
            })

        }

        loanTenureDays1(){
            this.setState({
            
            loanTypeBorder:"1px solid #D4D4D5",
            loanAmuontRangeBorder1:"1px solid #D4D4D5",
            loanAmuontRangeBorder2:"1px solid #D4D4D5",
            rateOfRangeInterestBorder1:"1px solid #D4D4D5",
            rateOfRangeInterestBorder2:"1px solid #D4D4D5",
            loanTenureMonthsBorder1:"1px solid #D4D4D5",
            loanTenureMonthsBorder2:"1px solid #D4D4D5",
            loanTenureWeeksBorder1:"1px solid #D4D4D5",
            loanTenureWeeksBorder2:"1px solid #D4D4D5",
            loanTenureDaysBorder1:"1px solid #D4D4D5",
            loanTenureDaysBorder2:"1px solid #D4D4D5",
          
            })
            
        }
       
    openprofileModal(){
        this.setState({
            openmodal : true
        })
    }
    closemodal(){
        this.setState({
            openmodal : false
        })
    }
   
    handleStatusChange(event) {
          this.setState({
            status: event.target.value
        });
    }
    handleDateChange = date => {
        this.setState({
            SelectedDate: date
        })
      };
   
    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { firstname, lastname,mobilenum, homeAddressLine, homeAddressStreet, homeAddressLandmark,homeAddressCity,
            homeAddressPincode, homeAddressState,OfficeAddressLine,OfficeAddressStreet, OfficeAddressCity,
            OfficeAddressLandmark, OfficeAddressPincode,OfficeAddressState } = this.state;
        if (firstname && lastname && mobilenum && homeAddressLine && homeAddressStreet && homeAddressLandmark &&homeAddressCity &&
            homeAddressPincode && homeAddressState &&OfficeAddressLine &&OfficeAddressStreet && OfficeAddressCity &&
            OfficeAddressLandmark && OfficeAddressPincode &&OfficeAddressState) {
            this.savegeneralinfo();
        }
    }
  

    validateFixedValues = () => {
        const {
            loanAmuontRangefrom,
            loanAmuontRangeto,
            fixedLoanAmount,
            fixedLoanCollectedAmount,
            fixedLoanTenureType,
            fixedLoanDuration,
            loanTenureMonthsfrom,
            loanTenureMonthsto,
            loanTenureWeeksfrom,
            loanTenureWeeksto,
            loanTenureDaysfrom,
            loanTenureDaysto,
        } = this.state;

        const loanAmount = Number(fixedLoanAmount);
        const collectedAmount = Number(fixedLoanCollectedAmount);
        const duration = Number(fixedLoanDuration);

        if (
            loanAmount < Number(loanAmuontRangefrom) ||
            loanAmount > Number(loanAmuontRangeto)
        ) {
            toast.error("Loan Amount must be within allowed range");
            return false;
        }

        if (fixedLoanTenureType === "Monthly") {
            if (
                duration < Number(loanTenureMonthsfrom) ||
                duration > Number(loanTenureMonthsto)
            ) {
                toast.error("Duration must be within Monthly range");
                return false;
            }
        }

        if (fixedLoanTenureType === "Weekly" || fixedLoanTenureType === "Bi-Weekly") {
            if (
                duration < Number(loanTenureWeeksfrom) ||
                duration > Number(loanTenureWeeksto)
            ) {
                toast.error("Duration must be within Weekly range");
                return false;
            }
        }

        if (
            fixedLoanTenureType === "Daily" ||
            fixedLoanTenureType === "Ten_Daily"
        ) {
            if (
                duration < Number(loanTenureDaysfrom) ||
                duration > Number(loanTenureDaysto)
            ) {
                toast.error("Duration must be within Daily range");
                return false;
            }
        }

        if (fixedLoanTenureType === "One Time") {
            if (duration !== 1) {
                toast.error("One Time loan must have duration = 1");
                return false;
            }
        }

        if (collectedAmount < loanAmount) {
            toast.error("Collected Amount cannot be less than Loan Amount");
            return false;
        }

        return true;
    };
     
      componentDidMount(){
        this.loantypeinfoGet()
        
        // this.setState({
        //   loanTypeId:this.props.location.params
        // })
    } 
      
      loantypeinfoGet(){
          let selectedLoanId = getSecureItem("EditLoanTypeID")
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ getSecureItem("token")
          }
      
        axios.get(BaseUrl + '/loanType/getLoanTypeDetails?loanTypeId=' +selectedLoanId,{
            headers: headers,
        }).then(resp => {
            if(resp.status===200) {
                this.setState({
                    loanType:resp.data.loanType,
                    loanAmuontRangefrom:resp.data.loanAmtRangeFrom,
                    loanAmuontRangeto:resp.data.loanAmtRangeTo,
                    fixedRoi: resp.data.fixedRoi,
                    rateOfRangeInterestfrom:resp.data.roiFrom,
                    rateOfRangeInterestto:resp.data.roiTo,
                    loanTenureMonthsfrom:resp.data.tenureMonthsFrom,
                    loanTenureMonthsto:resp.data.tenureMonthsTo,
                    loanTenureWeeksfrom:resp.data.tenureWeeksFrom,
                    loanTenureWeeksto:resp.data.tenureWeeksTo,
                    loanTenureDaysfrom:resp.data.tenureDaysFrom,
                    loanTenureDaysto:resp.data.tenureDaysTo,
                    fixedLoanTenureType: resp.data.fixedLoanTenureType,
                    fixedLoanDuration: resp.data.fixedLoanDuration,
                    fixedLoanAmount: resp.data.fixedLoanAmount,
                    fixedProcessingFee: resp.data.fixedProcessingFee,
                    fixedLoanCollectedAmount: resp.data.fixedLoanCollectedAmount
                })
            }else{
                toast.error("Something went wrong. Please try again later!", {
                    position: "top-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    });
            }
        }).catch(err => {
            if(err.request.status!==200){
            toast.error("Something went wrong. Please try again later!", {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                });
            }
        })
      }
      savechanges(){
        // if (!this.validateFixedValues()) {
        //     return;
        // }
          const data={
            "loanType": this.state.loanType,                     
            "loanTypeId": this.props.location.params,                       
           "loanAmtRangeFrom": this.state.loanAmuontRangefrom,           
           "loanAmtRangeTo": this.state.loanAmuontRangeto,    
           "fixedRoi": this.state.fixedRoi,          
           "roiFrom":  this.state.rateOfRangeInterestfrom,            
           "roiTo":   this.state.rateOfRangeInterestto,         
           "tenureMonthsFrom": this.state.loanTenureMonthsfrom,            
           "tenureMonthsTo":   this.state.loanTenureMonthsto,            
           "tenureWeeksFrom":   this.state.loanTenureWeeksfrom,           
           "tenureWeeksTo":     this.state.loanTenureWeeksto,       
           "tenureDaysFrom":   this.state.loanTenureDaysfrom,            
           "tenureDaysTo":    this.state.loanTenureDaysto,
           "fixedLoanTenureType": this.state.fixedLoanTenureType,
           "fixedLoanDuration": this.state.fixedLoanDuration,
           "fixedLoanAmount": this.state.fixedLoanAmount,
           "fixedProcessingFee": this.state.fixedProcessingFee,
           "fixedLoanCollectedAmount": this.state.fixedLoanCollectedAmount,
           "isDefault":false
          }
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ getSecureItem("token")
          }

        axios.put(BaseUrl + '/loanType/putLoanType',data,{
            headers: headers,
        }).then(resp => {
            if(resp.status===200) {
               this.props.history.push('/loantype')
            }else{
                toast.error("Something went wrong. Please try again later!", {
                    position: "top-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    });
            }
        }).catch(err => {
            if(err.request.status!==200){
            toast.error("Something went wrong. Please try again later!", {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                });
            }
        })
      }
    
      backLinkAction() {
        this.props.history.push('/loantype')      
      }


    render() {
      const { t } = this.props;
        return (
            <div>
                <Sidebar />
                {/* <AddLoanTypeHeader /> */}
                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                    {/* <div style={{width:'40%'}}>
                <img src={backbuttn} alt="backicon" style={{paddingLeft: '50px',paddingTop: '23px', cursor:'pointer'}} onClick={this.back.bind(this)} />
                </div> */}
                <div>
                        <h3 className="Fonts headFontSize" style={{ marginLeft: '45px' }}><span className="backLink" onClick={this.backLinkAction.bind(this)}>{this.state.loanType}</span> / {t('AddLoanType.edit')}</h3>
                    </div>
                   
                </div>
              
                <div className="addcustomercomponent" style={{marginTop:'3rem'}}>
                    {/* <span className="backLink" onClick={this.backLinkAction.bind(this)}></span> */}
                   
                    
                    <Card className="cardDiv">
                        <div className="previewComponent">
                            <form onSubmit={(e) => this._handleSubmit(e)}>
                                <div style={{ margin: '70px', marginTop: '34px', marginBottom: '34px' }}>
                                    <div style={{ display: 'flex' }}>
                                        <div className="textFieldStyle" style={{ width: '50%' }}>
                                            <h6 className="InputLabel Fonts SizeFont" >{t('AddLoanType.Type')}</h6>
                                            <Input className="textBox" value={this.state.loanType} defaultValue="Home Loan" style={{ height: '41px', border: this.state.loanTypeBorder }} onClick={this.loanType} onChange={(event) => this.setState({ loanType: event.target.value })} disabled/>
                                        </div>
                                        <div className="numaricTextField" style={{ width: '50%' }}>
                                            <h6 className="InputLabel Fonts SizeFont" style={{ marginLeft: '70px' }}>{t('AddLoanType.amtrange')}</h6>
                                            <Input type="text" value={this.state.loanAmuontRangefrom} defaultValue="500" className="textBox" style={{ height: '41px',width: '36%',marginLeft: '70px', border: this.state.loanAmuontRangeBorder1 }} onClick={this.loanAmuontRange1} onChange={(event) => this.setState({ loanAmuontRangefrom: event.target.value })} /> 
                                            <text> &nbsp; &nbsp;-</text> &nbsp; &nbsp;  
                                            <Input type="text" value={this.state.loanAmuontRangeto} defaultValue="50,00,000" className="textBox" style={{ height: '41px',width: '36%', marginLeft:'4px', border: this.state.loanAmuontRangeBorder2 }} onClick={this.loanAmuontRange2} onChange={(event) => this.setState({ loanAmuontRangeto: event.target.value })} />    
                                        </div> 
                                    </div>



                                    <div style={{ display: 'flex' }}>
                                        <div className="textFieldStyle" style={{ width: '50%' }}>
                                            <h6 className="InputLabel Fonts SizeFont" >{t('AddLoanType.intrstrange')}</h6>
                                            <Input className="textBox" value={this.state.rateOfRangeInterestfrom} defaultValue="0.8%" style={{ height: '41px',width: '32%' , border: this.state.rateOfRangeInterestBorder1 }} onClick={this.rateOfRangeInterestBox1} onChange={(event) => this.setState({ rateOfRangeInterestfrom: event.target.value })} />
                                           <text> &nbsp;% </text> &nbsp;&nbsp; <text> &nbsp; &nbsp;-&nbsp;&nbsp;</text> &nbsp;
                                            <Input className="textBox" value={this.state.rateOfRangeInterestto} defaultValue="47.8%" style={{ height: '41px',width: '32%', border: this.state.rateOfRangeInterestBorder2 }} onClick={this.rateOfRangeInterestBox2} onChange={(event) => this.setState({ rateOfRangeInterestto: event.target.value })} />
                                        <text> &nbsp;%</text>
                                        </div>
                                        <div className="numaricTextField" style={{ width: '50%' }}>
                                            <h6 className="InputLabel Fonts SizeFont" style={{ marginLeft: '70px' }}>{t('AddLoanType.tenuremonrange')}</h6>
                                            <Input type="text" value={this.state.loanTenureMonthsfrom} className="textBox" defaultValue="03" style={{ height: '41px',width: '36%', border: this.state.loanTenureMonthsBorder1, marginLeft: '70px' }} onClick={this.loanTenureMonthsBox1} onChange={(event) => this.setState({ loanTenureMonthsfrom: event.target.value })} />    
                                            <text> &nbsp; &nbsp;-</text> &nbsp; &nbsp;  
                                            <Input type="text" value={this.state.loanTenureMonthsto} className="textBox" defaultValue="24" style={{ height: '41px',width: '36%', border: this.state.loanTenureMonthsBorder2, marginLeft: '4px' }} onClick={this.loanTenureMonthsBox2} onChange={(event) => this.setState({ loanTenureMonthsto: event.target.value })} />
                                        </div>
                                    </div>  


                                    <div style={{ display: 'flex' }}>
                                        <div className="textFieldStyle" style={{ width: '50%' }}>
                                            <h6 className="InputLabel Fonts SizeFont" >{t('AddLoanType.tenureweekrange')}</h6>
                                            <Input className="textBox" value={this.state.loanTenureWeeksfrom} defaultValue="02" style={{ height: '41px',width: '38%' , border: this.state.loanTenureWeeksBorder1 }} onClick={this.loanTenureWeeksBox1} onChange={(event) => this.setState({ loanTenureWeeksfrom: event.target.value })} />
                                            <text> &nbsp; &nbsp;-</text> &nbsp; &nbsp;
                                            <Input className="textBox" value={this.state.loanTenureWeeksto} defaultValue="38" style={{ height: '41px',width: '38%', border: this.state.loanTenureWeeksBorder2 }} onClick={this.loanTenureWeeksBox2} onChange={(event) => this.setState({ loanTenureWeeksto: event.target.value })} />
                                        </div>
                                        <div className="numaricTextField" style={{ width: '50%' }}>
                                            <h6 className="InputLabel Fonts SizeFont" style={{ marginLeft: '70px' }}>{t('AddLoanType.tenuredayrange')}</h6>
                                            <Input type="text" value={this.state.loanTenureDaysfrom} className="textBox" defaultValue="05" style={{ height: '41px',width: '36%', border: this.state.loanTenureDaysBorder1, marginLeft: '70px' }} onClick={this.loanTenureDaysBox1} onChange={(event) => this.setState({ loanTenureDaysfrom: event.target.value })} />    
                                            <text> &nbsp; &nbsp;-</text> &nbsp; &nbsp;
                                            <Input type="text" value={this.state.loanTenureDaysto} className="textBox" defaultValue="365" style={{ height: '41px',width: '36%', border: this.state.loanTenureDaysBorder2, marginLeft: '4px' }} onClick={this.loanTenureDaysBox2} onChange={(event) => this.setState({ loanTenureDaysto: event.target.value })} />
                                        </div>
                                    </div>

                                </div>

                                <Grid container spacing={3} sx={{ px: 8, pt: 2, pb: 4 }}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" align="center" className="Fonts headFontSize">
                                        Fixed Values (for Flat Interest method - To Populate values automatically)
                                        </Typography>
                                    </Grid>

                                    {/* Row 1 */}
                                    <Grid item xs={12} sm={6}>
                                        <Typography className="InputLabel Fonts SizeFont" gutterBottom>
                                        Tenure Type
                                        </Typography>
                                        <Select
                                        styles={{
                                            container: (baseStyles, state) => ({
                                                ...baseStyles,
                                                width: "85%",
                                            }),
                                        }}
                                        className="textBox"
                                        options={tenureOptions}
                                        value={tenureOptions.find(
                                            (opt) => opt.value === this.state.fixedLoanTenureType
                                        )}
                                        onChange={(selected) =>
                                            this.setState({ fixedLoanTenureType: selected?.value })
                                        }
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Typography className="InputLabel Fonts SizeFont" gutterBottom>
                                        Rate of Interest
                                        </Typography>
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <Input
                                            className="textBox"
                                            fullWidth
                                            value={this.state.fixedRoi}
                                            style={{ height: 41, border: this.state.rateOfRangeInterestBorder1 }}
                                            onClick={this.rateOfRangeInterestBox1}
                                            onChange={(event) =>
                                            this.setState({ fixedRoi: event.target.value })
                                            }
                                        />
                                        <span>%</span>
                                        </div>
                                    </Grid>

                                    {/* Row 2 */}
                                    <Grid item xs={12} sm={6}>
                                        <Typography className="InputLabel Fonts SizeFont" gutterBottom>
                                        Loan Amount
                                        </Typography>
                                        <Input
                                        type="text"
                                        placeholder="Loan Amount"
                                        className="textBox"
                                        fullWidth
                                        value={this.state.fixedLoanAmount}
                                        onChange={(e) => this.setState({ fixedLoanAmount: e.target.value })}
                                        style={{ height: 41, border: "1px solid #D4D4D5" }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Typography className="InputLabel Fonts SizeFont" gutterBottom>
                                        Processing Fee
                                        </Typography>
                                        <Input
                                        type="text"
                                        placeholder="Processing Fee"
                                        className="textBox"
                                        fullWidth
                                        value={this.state.fixedProcessingFee}
                                        onChange={(e) => this.setState({ fixedProcessingFee: e.target.value })}
                                        style={{ height: 41, border: "1px solid #D4D4D5" }}
                                        />
                                    </Grid>

                                    {/* Row 3 */}
                                    <Grid item xs={12} sm={6}>
                                        <Typography className="InputLabel Fonts SizeFont" gutterBottom>
                                        Collected Amount
                                        </Typography>
                                        <Input
                                        type="text"
                                        placeholder="Repayable Amount"
                                        className="textBox"
                                        fullWidth
                                        value={this.state.fixedLoanCollectedAmount}
                                        onChange={(e) =>
                                            this.setState({ fixedLoanCollectedAmount: e.target.value })
                                        }
                                        style={{ height: 41, border: "1px solid #D4D4D5" }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Typography className="InputLabel Fonts SizeFont" gutterBottom>
                                        Duration
                                        </Typography>
                                        <Input
                                        type="text"
                                        placeholder="Duration"
                                        className="textBox"
                                        fullWidth
                                        value={this.state.fixedLoanDuration}
                                        onChange={(e) => this.setState({ fixedLoanDuration: e.target.value })}
                                        style={{ height: 41, border: "1px solid #D4D4D5" }}
                                        />
                                    </Grid>
                                </Grid>
                            
                            </form>
                        </div>
                    </Card>
                    <div style={{textAlign:"end"}}>
                        <Button  className="cancelbutton btnSizeFont Fonts" onClick={() => this.props.history.push("/loantype")}>
                            Cancel
                        </Button>
                        <Button  className="savebutton btnSizeFont Fonts" onClick={this.savechanges.bind(this)}>
                            Save
                        </Button>
                    </div>
                    
                </div>
            </div>
        )
    }
}
export default withNamespaces()(EditLoan);